  <div class="alert alert-danger mb-1" role="alert" *ngIf="errorMessage()">
    <i class="fa fa-exclamation-circle"></i> {{ removeTags(errorMessage()) }}
  </div>